import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (x) {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onLogout = () => setUser(false);
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const demoLogin = async (profile) => {
    const { data } = await api.post("/auth/demo-login", { profile });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, demoLogin, logout, reload: loadMe, setSession: setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const isAgent = (u) => u?.tenant_role === "agente";
export const homeFor = (u) => (u?.role === "superadmin" ? "/admin" : u?.role === "studio" ? "/studio" : isAgent(u) ? "/app/incassi" : "/app");
export const isAdmin = (u) => u?.role === "superadmin" || u?.tenant_role === "admin";
export const canWrite = (u) => u?.tenant_role !== "lettura";
